import { IconRotatingCircle } from "../../../common/icons/IconRotatingCircle/IconRotatingCircle";
import LeafFilterButton from "../../../common/leaf/LeafFilter/LeafFilterButton/LeafFilterButton";
import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/ssiUplineReport";
import { ExportDetails } from "../../../services/ExportV2/exportV2API.types";
import { MouseEventHandler, useEffect, useState } from "react";
import {
  MODULE_SSI_UPLINE_IN_WINDOW,
  MODULE_SSI_UPLINE_PRE_WINDOW,
  MODULE_SSI_UPLINE_OUT_OF_PROGRAM,
  MODULE_SSI_UPLINE_EARNED_PAYMENT,
  STATUS_DONE,
  STATUS_IN_PROGRESS,
  STATUS_PENDING,
} from "../../../common/constants/export-constants";
import { IconDownloadButton } from "../../../common/icons/IconDownloadButton/IconDownloadButton";
import { useAppSelector } from "../../../store";
import { ssiUplineReportTabs } from "../../../reducers/ssiUplineReport";
import useWindowSize from "../../../common/hooks/useWindowSize";
import "./ExportButton.scss";

type props = {
  visible: boolean;
  disabled: boolean;
  exportList: ExportDetails[];
  onClickFunction: MouseEventHandler<HTMLButtonElement>;
};

export const ExportButton = ({ visible, disabled, exportList, onClickFunction }: props) => {
  const { t } = useTranslation(["ssiUplineReport"]);
  const { activeView } = useAppSelector((state) => state.ssiUplineReportTracker);
  const [showInProgress, setShowInProgress] = useState(false);
  const [reportCount, setReportCount] = useState(0);
  const { width } = useWindowSize();

  useEffect(() => {
    const getExportTypeForView = () => {
      switch (activeView) {
        case ssiUplineReportTabs.GRACE_PERIOD_TAB:
          return MODULE_SSI_UPLINE_PRE_WINDOW;
        case ssiUplineReportTabs.IN_SSI_PROGRAM_TAB:
          return MODULE_SSI_UPLINE_IN_WINDOW;
        case ssiUplineReportTabs.OUT_SSI_PROGRAM_TAB:
          return MODULE_SSI_UPLINE_OUT_OF_PROGRAM;
        case ssiUplineReportTabs.EARNED_PAYMENT_TAB:
          return MODULE_SSI_UPLINE_EARNED_PAYMENT;
        default:
          return "";
      }
    };

    const reportsInView = exportList.filter((reports) => reports.ExportType === getExportTypeForView());
    setShowInProgress(
      reportsInView.some(({ ExportStatus }) => ExportStatus === STATUS_PENDING || ExportStatus === STATUS_IN_PROGRESS),
    );
    setReportCount(reportsInView.filter(({ ExportStatus }) => ExportStatus === STATUS_DONE).length);
  }, [exportList, activeView]);

  if (!visible) return <></>;

  return (
    <span
      className={`ssiExportButton ${disabled ? "ssiExportButton--disabled" : ""}`}
      style={{ position: "relative", display: "inline-block" }}
    >
      <LeafFilterButton
        text={""}
        onButtonClick={onClickFunction}
        theme="dark"
        disabled={disabled}
        aria-disabled={disabled}
        addStyleWhenFocussed={true}
        tabIndexData={{ ind: 2 }}
      >
        <span className="ssiExportButton__iconWrapper">
          {showInProgress ? <IconRotatingCircle /> : <IconDownloadButton width="1rem" height="1rem" />}
        </span>
        {width && width > 500 && t("export", defaultContent.export as string)}
      </LeafFilterButton>
      {reportCount > 0 && !disabled && <div className="ssiExportButton__notificationDot" />}
    </span>
  );
};
